import { useEffect, useState } from 'react';

import { Box, Button } from '@mui/material';
import { EntityField, Operator, SelectedEntityFields } from '../../../models/query-builder';
import ColumnOptionsModal from './column-options-modal';

import FiltersPage from './Filters/filters.page';
import { useSaveData } from '../../../hooks/useSaveData';
import { queryBuilderApiKeyStore } from '../../../api/query-builder-api-key-store';
import { useLoadData } from '../../../hooks/useLoadData';
import { ApiResponse } from '../../../models/api-response';

const CustomQueryPage = () => {
  const [selectedEntityFields, setSelectedEntityFields] = useState<SelectedEntityFields>({});
  const [entityFields, setEntityFields] = useState<EntityField[]>([]);
  const { isLoading, mutateAsync } = useSaveData<EntityField[]>(queryBuilderApiKeyStore.entityFieldGetAll('filter'));
  const { data, isLoading: isLoadingOperator } = useLoadData<ApiResponse<Operator[]>>(
    queryBuilderApiKeyStore.getOperator()
  );

  useEffect(() => {
    mutateAsync({ data: {} }).then((data) => {
      if (data?.data?.length > 0) {
        setEntityFields(data?.data);
        const defaultSelectedFields = data?.data?.reduce<SelectedEntityFields>((columns, field) => {
          if (field.selectedByDefault) {
            columns[field.entityFieldId] = field;
          }
          return columns;
        }, {});
        setSelectedEntityFields(defaultSelectedFields);
      }
    });
  }, []);

  // console.log(data);

  // useEffect(() => {
  //   if (fieldsMockData.length) {
  //     const defaultSelectedFields = fieldsMockData.reduce<SelectedEntityFields>((columns, field) => {
  //       if (field.SelectedByDefault) {
  //         columns[field.entityFieldId] = field;
  //       }
  //       return columns;
  //     }, {});
  //     setSelectedEntityFields(defaultSelectedFields);
  //   }
  // }, [fieldsMockData]);
  const [showColumnOptionsModal, setColumnOptionsModal] = useState(false);

  const handleColumnOptionModalClose = () => setColumnOptionsModal(false);

  const handleColumnOptionsModalSubmit = (updatedSelectedEntityFields: any) => {
    setSelectedEntityFields(updatedSelectedEntityFields);
  };

  return (
    <div>
      {' '}
      <Box>
        <Button
          disabled={!entityFields.length}
          onClick={() => setColumnOptionsModal(true)}
          variant="contained"
          style={{ marginTop: 12 }}
        >
          Column Options
        </Button>
        {data?.data && (
          <FiltersPage
            fields={entityFields}
            operators={data?.data || []}
            handleColumnOptionsModalSubmit={handleColumnOptionsModalSubmit}
            selectedEntityFields={selectedEntityFields} />
        )}
        {showColumnOptionsModal && (
          <ColumnOptionsModal
            isVisible={showColumnOptionsModal}
            onModalClose={handleColumnOptionModalClose}
            selectedEntityFields={selectedEntityFields}
            onSubmit={handleColumnOptionsModalSubmit}
            setSelectedEntityFields={setSelectedEntityFields}
          />
        )}
      </Box>
    </div>
  );
};

export default CustomQueryPage;
